import { ReadonlyValueDefinition } from 'models/metadata/readonlyValue.definition';
import type { Action } from 'state/actions';
import * as addonActionTypes from 'state/addonForm/addonForm.actionTypes';
import * as dynamicActionTypes from 'state/dynamic/dynamicForm.actionTypes';
import { addOrPatchKey, addOrReplaceKey, removeKey } from 'state/utils/collection';

import type { SidePanelUiState, SidePanelUiStateMap } from './sidePanelUi.model';
import { initialSidePanelUiState } from './sidePanelUi.model';

function mapMetadata(
  metadata: readonly ReadonlyValueDefinition[] | undefined,
): Readonly<Record<string, Readonly<ReadonlyValueDefinition>>> {
  return (
    metadata?.reduce<Record<string, ReadonlyValueDefinition>>((acc, field) => {
      acc[field.id] = field;
      return acc;
    }, {}) ?? {}
  );
}
export function sidePanelUiReducer(state: SidePanelUiStateMap = {}, action: Action): SidePanelUiStateMap {
  switch (action.type) {
    case 'QUOTE_REQUESTED':
    case dynamicActionTypes.DYNAMIC_BOOKING_REQUESTED:
    case addonActionTypes.ADDON_QUOTE_REQUESTED:
      return addOrReplaceKey(state, action.tabId, initialSidePanelUiState);
    case 'QUOTE_ACKED':
      return addOrPatchKey(
        state,
        action.tabId,
        prevState =>
          ({ ...prevState, fieldsMetadata: mapMetadata(action.sidePanelDetails) }) satisfies SidePanelUiState,
      );
    case 'PREVIOUS_QUOTE_LOADED':
    case 'QUOTE_RECEIVED':
      return addOrPatchKey(
        state,
        action.tabId,
        prevState =>
          ({
            ...prevState,
            metadata: { ...prevState.metadata, tradeWay: action.quote.tradeWay },
            fieldsMetadata: mapMetadata(action.quote.sidePanelDetails),
          }) satisfies SidePanelUiState,
      );

    case 'SIDE_PANEL_ACTIVE_TAB_CHANGED':
      return addOrPatchKey(state, action.tabId, prevState => ({
        ...prevState,
        activeTab: action.activeTab,
      }));

    case 'UPDATE_SIDE_PANEL_METADATA':
      return addOrPatchKey(state, action.tabId, prevState => ({
        ...prevState,
        metadata: { ...prevState.metadata, ...action.metadata },
      }));

    case 'WORKSPACE_TAB_REMOVED':
      return removeKey(state, action.id);

    case 'QUOTE_REMOVED':
      if (action.workspace !== 'static' && action.workspace !== 'dynamic') {
        return state;
      }
      return removeKey(state, action.tabId);

    default:
      return state;
  }
}
